var _defs, _circle, _line, _path, _path2, _line2, _line3, _line4, _line5, _path3, _g, _rect, _path4, _polyline, _g2, _line6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvgpeste1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 338.95 441.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{clip-path:url(#b);}.e{clip-path:url(#c);}.f{stroke:#000;stroke-linecap:round;stroke-miterlimit:10;stroke-width:10px;}.f,.g{fill:none;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M145.3,150.76l124.43,13.05s29.84,12,30.48,17.54-26.46,37.65-26.46,37.65l-21.08,9-69,26.16-13.74,85,40.39,50.17,49.42,25.29-40.14,22.08s-80.28,9-110.38,1-47.22-20.05-47.22-20.05c0,0-70.23-42.15-61.2-91.32,9.03-49.17,17.06-94.33,17.06-94.33l60.21-58.56,67.23-22.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M153.33,55.8v-20.68h24.08v25l25.09,2.88,16.06-18.6L209.56,2.25s-26.13-3.88-44.19-1.45-51.18,11.48-51.18,11.48l-31.1,18.07s27.09,20.07,31.1,22.07,34.12,7,34.12,7l5.02-3.62Z"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 246.15,
    cy: 315.84,
    r: 87.8
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 186.42,
    y1: 251.49,
    x2: 308.82,
    y2: 377.33
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M216.55,296.27c-2.39,2.1-9.71,9-11,20.07-2,16.89,11.84,28.3,14.05,30.1,11.61,9.32,27.35,11.62,41.14,6,17.74-7.32,23-25,25.09-32.11,.89-3,8.47-29.65-4-41.14-11.96-10.93-40.83-6.97-65.28,17.08Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M186.42,309.45s7.56-13.78,23.86-6"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 222.57,
    y1: 259.14,
    x2: 239.21,
    y2: 279.9
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 256.69,
    y1: 248.1,
    x2: 255.6,
    y2: 273.42
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 311.88,
    y1: 306.3,
    x2: 288.53,
    y2: 306.3
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 304.86,
    y1: 341.42,
    x2: 284.17,
    y2: 325.42
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M252.67,374.54s13-5.79,11-23.46"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "d"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 78.07,
    y: 177.86,
    width: 174.61,
    height: 230.8,
    rx: 36.2,
    ry: 36.2
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 102.15,
    y: 137.72,
    width: 124.43,
    height: 40.14,
    rx: 7.07,
    ry: 7.07
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M212.82,137.72c0-15-14.33-30.93-14.33-30.93h113.76c5.52,0,10-4.48,10-10v-9.32c0-5.52-4.48-10-10-10H59c-17.06,0-53.18,83.34-53.18,83.34v68.24c0,13,36.12,29.1,36.12,29.1v-80.24c0-23.08,33.82-70.25,33.82-70.25h55.5s-13.26,20.07-13.26,30.11"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "f",
    points: "177.41 48.41 177.41 77.51 153.33 77.51 153.33 48.41"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "e"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M141.79,19.31h46.21c8.02,.02,14.51,6.53,14.5,14.55h0c0,8.02-6.48,14.52-14.5,14.55h-46.21c-8.04,0-14.55-6.51-14.55-14.55h0c0-8.03,6.5-14.54,14.53-14.55,0,0,.01,0,.02,0Z"
  }))), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 278.53,
    y1: 77.51,
    x2: 278.53,
    y2: 106.79
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgpeste1);
export default __webpack_public_path__ + "static/media/svgpeste1.912a454da95e3ba5d6885027a036e9f8.svg";
export { ForwardRef as ReactComponent };